// extracted by mini-css-extract-plugin
export default {"wrapper":"toolbar-sort_wrapper__Ldf6P","label":"toolbar-sort_label__SuEzO","dropdown":"toolbar-sort_dropdown__SRJFH","buttons":"toolbar-sort_buttons__bjAJ3"};